import React from 'react';
import TaskThreadView from '../../../../../platform/ux/Campaigns/campaigndetails/components/TaskThreadView';

const TaskThreadController = (props) => {
  const {
    tasks,
    taskCount,
    tasksLoading,
    tasksError,
    refetchTasks,
    campaignId,
    currentUser,
    history,
    modalVisible,
    onModalClose,
  } = props;

  const handleCreateTask = () => {
    // Navigate to task creation form with campaign pre-selected
    history.push(`/tasks/form/new?campaignId=${campaignId}`);
  };

  return (
    <TaskThreadView
      tasks={tasks}
      taskCount={taskCount}
      tasksLoading={tasksLoading}
      tasksError={tasksError}
      handleCreateTask={handleCreateTask}
      currentUser={currentUser}
      modalVisible={modalVisible}
      onModalClose={onModalClose}
    />
  );
};

export default TaskThreadController;
